/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import {
  APPOINTMENT_URL,
  APPOINTMENT_TYPE_URL,
  AVAILABLE_APPOINTMENT_URL,
} from '@/config';

const getAppointments = (start, end) =>
  axios.get(APPOINTMENT_URL, {
    params: {
      expand: 'client',
      not_status: 10,
      after_time: start,
      before_time: end,
    },
  });
const getAppointmentTypes = () => axios.get(APPOINTMENT_TYPE_URL);
const addAppointment = appointment => axios.post(APPOINTMENT_URL, appointment);
const updateAppointment = appointment => axios.patch(`${APPOINTMENT_URL}/${appointment._id}`, appointment);
const deleteAppointment = appointment => axios.delete(`${APPOINTMENT_URL}/${appointment._id}`);
const getAvailableAppointments = ({ start, end }, locationId, duration, appointmentId) => {
  const params = {
    location_id: locationId,
    length_in_minutes: duration,
    block_length_minutes: duration,
    start_interval_minutes: 15,
    ignore_location_hours: 1,
    after_time: start,
    before_time: end,
  };
  if (appointmentId) {
    params.except_appointment_id = appointmentId;
  }
  return axios.get(AVAILABLE_APPOINTMENT_URL, { params });
};

export {
  getAppointments,
  getAppointmentTypes,
  addAppointment,
  updateAppointment,
  deleteAppointment,
  getAvailableAppointments,
};



// WEBPACK FOOTER //
// ./src/services/appointment.js